import {
    REQUEST_DOCUMENT_TEMPLATES,
    RECEIVE_DOCUMENT_TEMPLATES,
    UPDATE_DOCUMENT_TEMPLATES,
    ERROR_DOCUMENT_TEMPLATES
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import {reloadEnums} from "../actions"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_DOCUMENT_TEMPLATES
    };
}

export function receive(data) {
    return {
        type: RECEIVE_DOCUMENT_TEMPLATES,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_DOCUMENT_TEMPLATES,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_DOCUMENT_TEMPLATES,
        id,
        payload: data,
        updateType
    }
}

export function getDocumentTemplates(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().documentTemplates, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'document-templates',
                params: prepareFilters(params, getState(), "documentTemplates")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getDocumentTemplate(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('documentTemplate'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'document-templates/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createDocumentTemplate(data, fromSelect = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            if(!fromSelect){
                dispatch(requestItem())
            }
            return axios({
                method: 'POST',
                url: fetchUrl + 'document-templates',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                dispatch(reloadEnums('documentTemplates'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateDocumentTemplate(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('documentTemplate'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'document-templates/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadEnums('documentTemplates'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteDocumentTemplate(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'document-templates/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadEnums('documentTemplate'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}